<ng-container *ngIf="visible">
  <!-- Sobre completado: una sola línea con el N° BCR (el PDF se descarga con "Descargar contrato"). -->
  <ng-container *ngIf="completed; else inProgress">
    <p class="small">
      <span class="material-symbols-rounded text-success">account_balance</span>
      {{ 'ORDER_FORM.CONFIRMA.STATUS.COMPLETED'|translate: {id: status.document?.confirma_id} }}
    </p>
    <p *ngIf="status.post_alta_warning" class="small text-danger">
      <span class="material-symbols-rounded">warning</span>
      {{ 'ORDER_FORM.CONFIRMA.STATUS.POST_ALTA_WARNING'|translate }}
    </p>
  </ng-container>

  <ng-template #inProgress>
    <alert [type]="alertType">
      <div class="flex-center-distributed">
        <div>
          <span class="material-symbols-rounded">{{ view === 'blocked' || alertType === 'danger' ? 'warning' : 'account_balance' }}</span>
          <b>{{ 'ORDER_FORM.CONFIRMA.TITLE'|translate }}</b>
          <br>
          <ng-container [ngSwitch]="view">
            <span *ngSwitchCase="'retry_sent'">{{ 'ORDER_FORM.CONFIRMA.STATUS.RETRY_SENT'|translate }}</span>
            <span *ngSwitchCase="'voided'">
              {{ (expired ? 'ORDER_FORM.CONFIRMA.STATUS.VOIDED_EXPIRED' : status.document?.status?.label ? 'ORDER_FORM.CONFIRMA.STATUS.VOIDED' : 'ORDER_FORM.CONFIRMA.STATUS.VOIDED_NO_LABEL')|translate: {label: status.document?.status?.label} }}
            </span>
            <ng-container *ngSwitchCase="'blocked'">
              <span *ngIf="reason; else blockedGeneric">{{ reason }}</span>
              <ng-template #blockedGeneric>{{ (status.enqueue_failed ? 'ORDER_FORM.CONFIRMA.STATUS.NOT_SENT' : 'ORDER_FORM.CONFIRMA.STATUS.BLOCKED_GENERIC')|translate }}</ng-template>
            </ng-container>
            <span *ngSwitchCase="'processing'">{{ reason || ('ORDER_FORM.CONFIRMA.STATUS.PROCESSING'|translate) }}</span>
            <span *ngSwitchCase="'pending_control'">
              {{ 'ORDER_FORM.CONFIRMA.STATUS.PENDING_CONTROL'|translate: {id: status.document.confirma_id} }}
            </span>
            <span *ngSwitchCase="'in_signature'">
              {{ 'ORDER_FORM.CONFIRMA.STATUS.IN_SIGNATURE'|translate: {id: status.document.confirma_id} }}
              <a *ngIf="status.confirma_url" [href]="status.confirma_url" target="_blank" rel="noopener noreferrer">{{ 'ORDER_FORM.CONFIRMA.STATUS.GO_TO_CONFIRMA'|translate }}</a>
            </span>
            <span *ngSwitchCase="'pending_registration'">
              {{ 'ORDER_FORM.CONFIRMA.STATUS.PENDING_REGISTRATION'|translate: {id: status.document.confirma_id} }}
            </span>
            <span *ngSwitchCase="'registered'">
              {{ 'ORDER_FORM.CONFIRMA.STATUS.REGISTERED_PDF_SOON'|translate: {id: status.document.confirma_id} }}
            </span>
            <ng-container *ngSwitchDefault>
              <span *ngIf="status.document?.status?.label; else noLabel">
                {{ 'ORDER_FORM.CONFIRMA.STATUS.IN_PROGRESS'|translate: {id: status.document?.confirma_id, label: status.document.status.label} }}
              </span>
              <ng-template #noLabel>{{ 'ORDER_FORM.CONFIRMA.STATUS.IN_PROGRESS_NO_LABEL'|translate: {id: status.document?.confirma_id} }}</ng-template>
            </ng-container>
          </ng-container>
          <div *ngIf="status.post_alta_warning" class="text-danger small">{{ 'ORDER_FORM.CONFIRMA.STATUS.POST_ALTA_WARNING'|translate }}</div>
          <div *ngIf="retryError" class="text-danger small">{{ 'ORDER_FORM.CONFIRMA.STATUS.RETRY_ERROR'|translate }}</div>
        </div>
        <button type="button" class="btn btn-default btn-sm"
        *ngIf="showRetry"
        [disabled]="processing"
        (click)="retry()">
          <span class="material-symbols-rounded">refresh</span> {{ 'ORDER_FORM.CONFIRMA.STATUS.RETRY'|translate }}
        </button>
      </div>
    </alert>
  </ng-template>
</ng-container>
